<template>
  <div class="col p-0">
    <ColorPointsHeader :message="greenHeaderMessage" color="rgba(190, 206, 35, 0.5)" />
    <div class="row center">
      <div class="col-md-1 col-lg-2"></div>
      <div class="col-12 col-md-10 col-lg-8">
        <div class="text-center" v-html=" focus.paragraphe1 ? focus.paragraphe1.texte : '' "></div>
      </div>
      <div class="col-md-1 col-lg-2"></div>
    </div>
    <div class="bg-light-green d-flex align-items-center p-3 mt-5">
      <div class="row">
        <div class="col-lg-2"></div>
        <div class="col-12 col-lg-8 d-flex justify-content-center">
          <div>
            <img width="55px" height="55px" class="m-1" :src=" focus.paragraphe2 ? focus.paragraphe2.image : '' " alt="image"/>
            <div style="height: 0.3rem; width: 7rem" class="bg-primary mt-1"></div>
            <h5 class="text-uppercase text-secondary font-weight-bold mt-2 text-left" v-html=" focus.paragraphe2 ? focus.paragraphe2.titre : '' "></h5>
            <div v-html=" focus.paragraphe2 ? focus.paragraphe2.texte : '' "></div>
          </div>
          <div style="width: 1rem" class="bg-grey ml-3 mr-3"></div>
          <div>
            <img width="52px" height="55px" class="m-1" :src=" focus.paragraphe3 ? focus.paragraphe3.image : '' " alt="image"/>
            <div style="height: 0.3rem; width: 7rem" class="bg-primary mt-1"></div>
            <h5 class="text-uppercase text-secondary font-weight-bold mt-2 text-left" v-html=" focus.paragraphe3 ? focus.paragraphe3.titre : '' "></h5>
            <div v-html=" focus.paragraphe3 ? focus.paragraphe3.texte : '' "></div>
          </div>
          <div style="width: 1rem" class="bg-grey ml-3 mr-3"></div>
          <div>
            <img width="52px" height="55px" class="m-1" :src=" focus.paragraphe4 ? focus.paragraphe4.image : '' " alt="image"/>
            <div style="height: 0.3rem; width: 7rem" class="bg-primary mt-1"></div>
            <h5 class="text-uppercase text-secondary font-weight-bold mt-2 text-left" v-html=" focus.paragraphe4 ? focus.paragraphe4.titre : '' "></h5>
            <div v-html=" focus.paragraphe4 ? focus.paragraphe4.texte : '' "></div>
          </div>
        </div>
        <div class="col-lg-2"></div>
      </div>
    </div>
    <div class="bg-grey p-5 d-flex align-items-center flex-column">
        <img width="52px" height="55px" class="m-1" src="../../assets/images/icon-demande-pret@3x.png" alt="image"/>
        <div style="height: 0.3rem; width: 7rem" class="bg-primary"></div>
        <h1>Demande de prêt</h1>
        <router-link class="text-uppercase text-dark" :to="{ name: 'DemandePretForm' }">Accéder au formulaire -></router-link>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import { getFocus } from '../../mixins/getFocus'

export default {
  name: 'FinancementImmobilierProfessionnels',
  mixins: [getFocus],
  components: {
    ColorPointsHeader: () => import('../../components/ColorPointsHeader')
  },
  data () {
    return {
      greenHeaderMessage: {
        titre: '',
        sousTitre: ''
      },
      focus: []
    }
  },
  async beforeMount () {
    await this.getFocus('CG Courtage', 'Financement immobilier et professionnels')
      .then(res => {
        this.focus = res
        this.greenHeaderMessage.titre = this.focus.cartouche ? this.focus.cartouche.titre : ''
        this.greenHeaderMessage.sousTitre = this.focus.cartouche ? this.focus.cartouche.texte : ''
      })
  }
}
</script>
<style lang="scss" scoped>
.bg-light-green {
  background-color: #BECE234D;
}
.list-unstyled ul {
  list-style: none;
  padding-left: 0;
}
</style>
